export const roles = [
  { label: "Super Staff", value: "super_staff" },
  { label: "Staff", value: "staff" },
  { label: "Developer staff", value: "developer_staff" },
  { label: "KYC Staff", value: "kyc_staff" },
];
